import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import { MdOutlineEmail } from 'react-icons/md'
import './contact.css'

const Contact = () => {
  const [submitted, setSubmitted] = useState(false)
  const formRef = useRef(null)
  const nameRef = useRef(null)
  const emailRef = useRef(null)
  const messageRef = useRef(null)

  const handleSubmit = (e) => {
    console.log(
      'Form Values : ',
      emailRef.current.value + nameRef.current.value + messageRef.current.value
    )
    e.preventDefault()
    setSubmitted(true)
    // send the message and email with the form values
    emailjs.send(
      'service_rp15kph',
      'template_w7djbk6',
      {
        from_name: nameRef.current.value,
        from_email: emailRef.current.value,
        message_html: messageRef.current.value,
        message: messageRef.current.value,
      },

      'gxoiRtfe4ATC4tQJn'
    )
    //emailjs
    //  .sendForm(
    //    'service_rp15kph',
    //    'template_w7djbk6',
    //    formRef.current,
    //    'gxoiRtfe4ATC4tQJn'
    //  )
    //  .then(
    //    (result) => {
    //      console.log(result.text)
    //    },
    //    (error) => {
    //      console.log(error.text)
    //    }
    //  )

    e.target.reset()
  }

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h5>
        I do receive your messages and will respond asap if the valid email is
        provided :)
      </h5>
      <h2>Contact Me</h2>
      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>benkhaledzineddine@gmail.com</h5>
            <a href='mailto:benkhaledzineddine@gmail.com'>Send a message</a>
          </article>
        </div>
        <form ref={formRef} onSubmit={handleSubmit}>
          <input
            type='text'
            placeholder='Your Full Name'
            name='user_name'
            ref={nameRef}
            required
          />
          <input
            type='email'
            placeholder='Your Email'
            name='user_email'
            ref={emailRef}
            required
          />
          <textarea
            placeholder='Your message'
            rows='7'
            name='message'
            ref={messageRef}
            required
          ></textarea>
          <button type='submit' className='btn btn-primary'>
            Send Message
          </button>
          {submitted && <span>Thanks, I'll reply ASAP :)</span>}
        </form>
      </div>
    </section>
  )
}

export default Contact
